export default [
    // {
    //   title: 'แดชบอร์ด',
    //   route: 'admin-dashboard',
    //   icon: 'HomeIcon',
    //   resource: 'BranchAdmin',
    //   action: 'manage',
    // },
    {
      title: 'ข้อมูลลูกค้า',
      route: 'admin-branch-customer',
      icon: 'UserIcon',
      resource: 'BranchAdmin',
      action: 'manage',
    },
    {
      title: 'ตรวจสอบแจ้งชำระเงิน',
      route: 'admin-branch-check-payment',
      icon: 'CheckSquareIcon',
      resource: 'BranchAdmin',
      action: 'manage',
    },
    {
      title: 'สถานะใบสั่งซื้อ',
      route: 'admin-branch-order-status',
      icon: 'FileTextIcon',
      resource: 'BranchAdmin',
      action: 'manage',
    },
    {
      title: 'ตั้งค่านำเข้ามาตรฐาน',
      route: 'admin-branch-shipping-rate-standard',
      icon: 'TruckIcon',
      resource: 'BranchAdmin',
      action: 'manage',
    },
    {
      title: 'ตั้งค่านำเข้ารายลูกค้า',
      route: 'admin-branch-shipping-rate-customer',
      icon: 'DollarSignIcon',
      resource: 'BranchAdmin',
      action: 'manage',
    },
    {
      title: 'ตั้งค่าผู้ดูแลระบบ',
      route: 'admin-branch-admin-setting',
      icon: 'SettingsIcon',
      resource: 'BranchAdmin',
      action: 'manage',
    },
  ]
